'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = payment;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isPayOrder: false,
    isCustomPayment: false,
    preload: false,
    processInput: {},
    list: [],
    pipoList: [],
    errorPay: null,
    errorCode: null
};

function payment() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.PaymentConstants.CHECK_CODE_SEND_INNER_PIPO_FAIL:
            return (0, _extends3.default)({}, state, {
                errorPay: action.error.message,
                errorCode: action.error.code
            });
            break;
        case _constants.PaymentConstants.SHOW:
            return state;
            break;
        case _constants.PaymentConstants.SHOW_SUCCESS:
            return (0, _extends3.default)({}, state, {
                list: action.result.services
            });
            break;
        case _constants.PaymentConstants.SHOW_FAIL:
            return state;
            break;

        case _constants.PaymentConstants.PAY_INNER_PIPO_RESET:
            return (0, _extends3.default)({}, state, {
                isPayOrder: false,
                errorPay: null,
                errorCode: null
            });
            break;
        case _constants.PaymentConstants.PAY_INNER_PIPO_FAIL:
            return (0, _extends3.default)({}, state, {
                isPayOrder: false,
                preload: false,
                errorPay: action.error.message,
                errorCode: action.error.code
            });
            break;
        case _constants.PaymentConstants.PAY_INNER_PIPO_REQUEST:
            return (0, _extends3.default)({}, state, {
                isPayOrder: false,
                preload: true,
                errorPay: null,
                errorCode: null
            });
            break;
        case _constants.PaymentConstants.PAY_INNER_PIPO_SUCCESS:
            return (0, _extends3.default)({}, state, {
                isPayOrder: true,
                preload: false,
                errorPay: null,
                errorCode: null
            });
            break;

        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_REQUEST:
            return (0, _extends3.default)({}, state, {
                preload: true,
                processInput: {}
            });
            break;
        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                preload: false,
                processInput: action.result
            });
            break;
        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_RESET:
        case _constants.PaymentConstants.PIPO_PROCESS_INPUT_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                processInput: {}
            });
            break;
        case _constants.PaymentConstants.PIPO_PAY_PARAMS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                pipoList: action.result.params
            });
            break;

        case _constants.PaymentConstants.SET_CUSTOM_PAYMENT:
            return (0, _extends3.default)({}, state, {
                isCustomPayment: true
            });
            break;
        case _constants.PaymentConstants.RESET_CUSTOM_PAYMENT:
            return (0, _extends3.default)({}, state, {
                isCustomPayment: false
            });
            break;

        default:
            return state;
            break;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/payment.js
// module id = 1908
// module chunks = 0